import { ApiGet } from "../helper";
import { IApiResponse } from "../type-interface";

export const FetchAll = async (queryString: string): Promise<IApiResponse> => {
    const response = await ApiGet(`/accounting/coa/full${queryString}`);
    return response;
}
